'use client';

import { AppCard } from '@ui/components/layouts';
import { text as sharedText } from '@shared/text';
import { text } from '@modules/garden-preferences/text';

export function GardenPreferences() {
  return (
    <div className="flex w-full flex-col gap-6">
      <h2 className="text-foreground text-xl font-semibold">{text.sectionTitle}</h2>

      <AppCard className="p-5">
        <p className="text-muted-foreground text-base">{sharedText.comingSoon}</p>
      </AppCard>
    </div>
  );
}
